"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterIssues(issues, filter) {
    const filters = Object.entries(filter);
    return issues.filter((issue) => {
        for (const [key, filterValue] of filters) {
            const issueValue = issue[key];
            if (typeof issueValue === 'undefined') {
                return false;
            }
            const filterIsArray = Array.isArray(filterValue);
            const valueIsArray = Array.isArray(issueValue);
            if (valueIsArray) {
                if (filterIsArray) {
                    return filterValue.some(value => issueValue.includes(value));
                }
                else {
                    return issueValue.includes(filterValue);
                }
            }
            else if (filterIsArray) {
                return filterValue.some(value => value === issueValue);
            }
            else if (issueValue !== filterValue) {
                return false;
            }
        }
        return true;
    });
}
exports.default = filterIssues;
//# sourceMappingURL=issue-filter.js.map